'use strict'

var position = exports

position.start = factory('start')
position.end = factory('end')

function factory(type) {
  point.displayName = type

  return point

  function point(node) {
    var point = (node && node.position && node.position[type]) || {}

    return {
      line: point.line || null,
      column: point.column || null,
      offset: isNaN(point.offset) ? null : point.offset
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/unist-util-position/index.js
// module id = 298
// module chunks = 0